import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/CalculatorWizard";
import Report from "@/pages/Report";
import Compare from "@/pages/Compare";
import Cohort from "@/pages/Cohort";
import Pricing from "@/pages/Pricing";
import { HowItWorks, Benchmarks, ForCMOs, ForFinance } from "@/pages/ContentPages";
import { Privacy, Terms, Imprint } from "@/pages/LegalPages";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import { ThemeProvider } from "@/lib/theme";
import GdprBanner from "@/components/GdprBanner";

function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
      <div className="App min-h-screen bg-[#F8F9FA] text-slate-900">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/cohort" element={<Cohort />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/benchmarks" element={<Benchmarks />} />
            <Route path="/for-cmos" element={<ForCMOs />} />
            <Route path="/for-finance-teams" element={<ForFinance />} />
            <Route path="/convince-your-cfo" element={<ForFinance />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/report/:slug" element={<Report />} />
          </Routes>
          <GdprBanner />
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
